<div class="row row-sm add-form">
    <form autocomplete="off" class="p-0" novalidate [formGroup]="SessionCutOff ">
        <div class="col-lg-12 col-md-12">
            <div class="card-body">

                <div class="bc d-flex align-items-center pl-3" *ngIf="submitButton">
                    <img alt="Logo" src="../../assets/img/SessionCutoff.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Session-CutOff Dates
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Add New Session-CutOff Information
                        </p>
                    </div>
                </div>
                <div class="bc d-flex align-items-center pl-3" *ngIf="editButton">
                    <img alt="Logo" src="../../assets/img/SessionCutoff.png" class="mh-40px pb-2">
                    <div class="ml-2">
                        <h3 class="main-content-label mb-1"><b>
                                Session-CutOff Dates
                            </b></h3>
                        <p class="text-muted card-sub-title mb-0">
                            Update Selected Session-CutOff Information
                        </p>
                    </div>
                </div>
                <hr>
                <div class="row clearfix">

                    <div class="col">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>Session</mat-label>
                            <mat-select [disabled]="isdisabled" #select22 placeholder="Session" class="colorblack"
                                formControlName="SessionID" required>
                                <mat-select-filter *ngIf="select22.focused" [placeholder]="'Filter'"
                                    [displayMember]="'SnName'" [array]="sessionList"
                                    (filteredReturn)=" SessionFilterList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of  SessionFilterList" (click)="selectSessionID(item.SnNo)"
                                    [value]="item.SnNo">
                                    {{item.SnNo}} - {{item.SnName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="SessionCutOff.controls['SessionID'].touched && SessionCutOff.controls['SessionID'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label>{{'header.faculty-data.titleList.Faculty'| translate }}</mat-label>
                           <mat-select [disabled]="isdisabled" required #select33 placeholder="CoFcCode"
                                class="colorblack" formControlName="CoFcCode" (selectionChange)="onFacultyChange($event.value)">
                                <mat-select-filter *ngIf="select33.focused" [placeholder]="'Filter'"
                                  [displayMember]="'FcDesc'" [array]="fcCodeList"
                                  (filteredReturn)="filteredListFcCode =$event">
                                </mat-select-filter>
                                <mat-option *ngFor="let item of filteredListFcCode" [value]="item.FcCode">
                                  {{item.FcCode}} - {{item.FcDesc}}
                                </mat-option>
                              </mat-select>
                             <mat-error class="margin_tp"
                                *ngIf="SessionCutOff.controls['CoFcCode']?.touched && SessionCutOff.controls['CoFcCode'].errors?.required">
                                Mandatory
                              </mat-error>
                        </mat-form-field>
                    </div>
               
                    <div *ngIf="!SelectAllActive" class="col">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label> College Name</mat-label>
                            <mat-select required [disabled]="isdisabled" #select23 placeholder="CgCode"
                                class="colorblack" formControlName="CoCgCgCode">
                                <mat-select-filter *ngIf="select23.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CgName'" [array]="collegeList"
                                    (filteredReturn)="filteredCollegeList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredCollegeList" (click)="fetchCourse(item.CgCode)"
                                    [value]="item.CgCode">
                                    {{item.CgCode}} - {{item.CgName}}
                                </mat-option>
                              </mat-select>
                              <mat-error class="margin_tp"
                                *ngIf="SessionCutOff.controls['CoCgCgCode'].touched && SessionCutOff.controls['CoCgCgCode'].errors?.required">
                                Mandatory
                              </mat-error>
                            </mat-form-field>
                      </div>
                      <!-- <div class="col">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label> Course Name</mat-label>
                            <mat-select required [disabled]="isdisabled" #select29 placeholder="CoCode"
                                class="colorblack" formControlName="CoCgCoCode"
                                (selectionChange)="onCourseChange($event.value)">
                                <mat-select-filter *ngIf="select29.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CoName'" [array]="CourseList"
                                    (filteredReturn)="filteredCourseList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredCourseList" [value]="item.CoCgCoCode"
                                    (click)="CourseData(item)" (click)="fetchSupExamRecord(item.CoCgCoCode)">
                                    {{item.CoCgCoCode}} - {{item.CoName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="SessionCutOff.controls['CoCgCoCode'].touched && SessionCutOff.controls['CoCgCoCode'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div> -->
                       <div class="col">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label> Course Name</mat-label>
                            <mat-select required [disabled]="isdisabled" placeholder="CoCode"
                                class="colorblack" formControlName="CoCgCoCode" multiple
                                (selectionChange)="onCourseSelect($event)">
                                <mat-option (click)="selectAllCourses()" [value]="'selectAll'" [checked]="isAllCoursesSelected()">
                                    Select All
                                </mat-option>
                                <mat-option *ngFor="let item of filteredCourseList" [value]="item.CoCgCoCode"
                                    [checked]="selectedCourses.includes(item.CoCgCoCode)">
                                    {{item.CoCgCoCode}} - {{item.CoName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="SessionCutOff.controls['CoCgCoCode'].touched && SessionCutOff.controls['CoCgCoCode'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <!-- <div *ngIf="!SelectAllActive" class="col">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label> Course Name</mat-label>
                            <mat-select required [disabled]="isdisabled" #select29 placeholder="CoCode"
                                class="colorblack" formControlName="CoCgCoCode">
                                <mat-select-filter *ngIf="select29.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CoName'" [array]="CourseList"
                                    (filteredReturn)="filteredCourseList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredCourseList" [value]="item.CoCgCoCode"
                                    (click)="CourseData(item)" (click)="fetchSupExamRecord(item.CoCgCoCode)">
                                    {{item.CoCgCoCode}} - {{item.CoName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="SessionCutOff.controls['CoCgCoCode'].touched && SessionCutOff.controls['CoCgCoCode'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div> -->
                   <!-- College Name Dropdown -->
                    <div *ngIf="SelectAllActive" class="col">
                        <mat-form-field appearance="outline" class="example-full-width">
                        <mat-label>College Name</mat-label>
                        <mat-select required [disabled]="isdisabled" placeholder="CgCode" 
                         (selectionChange)="onCollegeSelect($event)"
                            class="colorblack" formControlName="CoCgCgCode" multiple>
                                <mat-option (click)="selectAllColleges()" [value]="'selectAll'" [checked]="isAllCollegesSelected()">
                            Select All
                        </mat-option>
                                <mat-option *ngFor="let item of filteredCollegeList" disabled="false" [value]="item.CgCode" [checked]="selectedColleges.includes(item.CgCode)">
                                    {{item.CgCode}} - {{item.CgName}}
                        </mat-option>
                        </mat-select>
                            <mat-error class="margin_tp" *ngIf="SessionCutOff.controls['CoCgCgCode'].touched && SessionCutOff.controls['CoCgCgCode'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div>


                    <!-- <div *ngIf="SelectAllActive" class="col">
                        <mat-form-field appearance="outline" class="example-full-width">
                            <mat-label> Course Name</mat-label>
                            <mat-select required [disabled]="isdisabled" #select29 placeholder="CoCode"
                                class="colorblack" formControlName="CoCgCoCode">
                                <mat-select-filter *ngIf="select29.focused" [placeholder]="'Filter'"
                                    [displayMember]="'CoName'" [array]="CourseList"
                                    (filteredReturn)="filteredCourseList =$event"></mat-select-filter>
                                <mat-option *ngFor="let item of filteredCourseList" [value]="item.CoCode"
                                    (click)="CourseData(item)" (click)="fetchSupExamRecord(item.CoCode)">
                                    {{item.CoCode}} - {{item.CoName}}
                                </mat-option>
                            </mat-select>
                            <mat-error class="margin_tp"
                                *ngIf="SessionCutOff.controls['CoCgCoCode'].touched && SessionCutOff.controls['CoCgCoCode'].errors?.required">
                                Mandatory
                            </mat-error>
                        </mat-form-field>
                    </div> -->

                    
                    <div class="col">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>Activity</mat-label>
                                    <mat-select [disabled]="isdisabled" formControlName="InCode" #select3904 placeholder="Activity" class="colorblack">
                                        <mat-select-filter *ngIf="select3904.focused" [placeholder]="'Activity'" [displayMember]="'CdCode'" [array]="ExamInputList" (filteredReturn)="filteredExamInputList =$event">
                                        </mat-select-filter>
                                        <mat-option *ngFor="let item of filteredExamInputList" [value]="item.CdCode" (click)="toggleExamDropdown(item.CdCode)">
                                           {{item.CdDesc}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error class="margin_tp"
                                *ngIf="SessionCutOff.controls['InCode'].touched && SessionCutOff.controls['InCode'].errors?.required">
                                Mandatory
                            </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                     <!-- <div class="col-sm-12" *ngIf="examDropdownVisible">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>Exam Available</mat-label>
                                    <mat-select [disabled]="isdisabled" formControlName="EmId" #select3901 required placeholder="Exam Available" class="colorblack">
                                        <mat-select-filter *ngIf="select3901.focused" [placeholder]="'Exam Available'" [displayMember]="'EmName'" [array]="ExamAList" (filteredReturn)="filteredExamAList =$event">
                                        </mat-select-filter>
                                        <mat-option *ngFor="let item of filteredExamAList" [value]="item.EmId" (click)="getdates()">
                                            {{item.EmCode}} - {{item.EmName}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error class="margin_tp"
                                *ngIf="SessionCutOff.controls['EmId'].touched && SessionCutOff.controls['EmId'].errors?.required">
                                Mandatory
                            </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div> -->

                   
                    <div class="col-sm-12" *ngIf="examDropdownVisible">
                        <div class="form-group">
                            <div class="">
                                <mat-form-field appearance="outline" class="example-full-width">
                                    <mat-label>Exam Available</mat-label>
                                    <mat-select [disabled]="isdisabled" formControlName="EmId" #select3901 required placeholder="Exam Available" class="colorblack" multiple
                                        (selectionChange)="onExamSelect($event)">
                                        <mat-option (click)="selectAllExams()" [value]="'selectAll'" [checked]="isAllExamsSelected()">
                                            Select All
                                        </mat-option>
                                        <mat-option *ngFor="let item of filteredExamAList" [value]="item.EmId"
                                            [checked]="selectedExams.includes(item.EmId)">
                                            {{item.EmCode}} - {{item.EmName}}
                                        </mat-option>
                                    </mat-select>
                                    <mat-error class="margin_tp"
                                *ngIf="SessionCutOff.controls['EmId'].touched && SessionCutOff.controls['EmId'].errors?.required">
                                Mandatory
                            </mat-error>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-12" *ngIf="SessionCutOff.value.InCode === 'ASC' && examDropdownVisible">
                        <div class="alert alert-info mb-2" role="alert">
                            <!-- <i class="fas fa-info-circle mr-2"></i> -->
                            <!-- <b>Note:</b> These cutoff dates will control when students can apply for <b>Student Request</b>. Students can only submit their ASC request during the date range specified below. -->
                        </div>
                    </div>

                    <!-- (click)="loadExamRecords(); reset(item.ShId)" -->

                    <div class="table-responsive table-container mt-3" *ngIf="Table">
                        <table  class="table  table-bordered text-nowrap text-left">
                            <thead>
                                <tr class="text-center">
                                    <th class="f600">From Date</th>
                                    <th class="f600 ">To Date</th>
                                    <th class="f600 ">Add</th>
                                </tr>
                            </thead>
                            <tbody id="table_data" formArrayName="DateArray">
                                <tr *ngFor="let d of getFormControls();let last = last; let i = index"
                                    [formGroupName]="i">
                                    <td>
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>Choose From Date</mat-label>
                                            <input (click)="action(d)" [readonly]="!last || disableDate" class="color" matInput
                                                [matDatepicker]="picker" (dateChange)="datechange(i)"
                                                placeholder="CutOff Date" formControlName="CutOffDateFrom"
                                                >
                                                <!-- [matDatepickerFilter]="dateFilter" -->
                                            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                                            <mat-datepicker [disabled]="!last || disableDate" #picker></mat-datepicker>
                                            <mat-error class="margin_tp mrgtp"
                                                *ngIf="d.controls.CutOffDateFrom.touched && d.controls.CutOffDateFrom.errors?.required">
                                                Mandatory
                                            </mat-error>
                                            <mat-error class="margin_tp mrgtp"
                                                *ngIf="d.controls.CutOffDateFrom.touched && d.controls.CutOffDateFrom.errors?.SameDateError">
                                               Date Cannot Be Same As Previous ToDate
                                            </mat-error>
                                            <mat-error class="margin_tp mrgtp"
                                                *ngIf="d.controls.CutOffDateFrom.touched && d.controls.CutOffDateFrom.errors?.FromdateError">
                                               Date Cannot Be Less Than Previous To Date
                                            </mat-error>
                                            <mat-error class="margin_tp mrgtp"
                                                *ngIf="d.controls.CutOffDateFrom.touched && d.controls.CutOffDateFrom.errors?.TodaydateError">
                                               Date Cannot Be Less Than Today's Date
                                            </mat-error>
                                            
                                            
                                            <!-- <mat-error class="margin_tp mrgtp"
                                                *ngIf="d.controls.From.touched && d.controls.From.errors?.pattern">
                                               Invalid
                                            </mat-error> -->
                                        </mat-form-field>
                                    </td>
                                    <td>
                                        <mat-form-field appearance="outline" class="example-full-width">
                                            <mat-label>Choose To Date</mat-label>
                                            <input (click)="action(d)" [readonly]="!last || disableDate" class="color" matInput
                                                [matDatepicker]="picker1" (dateChange)="datechange1(i)"
                                                placeholder="CutOff Date" formControlName="CutOffDate"
                                                >
                                                <!--[matDatepickerFilter]="dateFilter" -->
                                            <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
                                            <mat-datepicker [disabled]="!last || disableDate" #picker1 ></mat-datepicker>
                                            <mat-error class="margin_tp mrgtp"
                                                *ngIf="d.controls.CutOffDate.touched && d.controls.CutOffDate.errors?.required">
                                                Mandatory
                                            </mat-error>
                                            <mat-error class="margin_tp mrgtp"
                                                *ngIf="d.controls.CutOffDate.touched && d.controls.CutOffDate.errors?.dateError">
                                               Date Cannot Be Less Than Or Equal To From Date
                                            </mat-error>
                                            <mat-error class="margin_tp mrgtp"
                                            *ngIf="d.controls.CutOffDate.touched && d.controls.CutOffDate.errors?.TodaydateError">
                                           Date Cannot Be Less Than Today's Date
                                        </mat-error>
                                        </mat-form-field>
                                    </td>
                                    <td class="text-center">
                                        <i class="fa fa-plus" *ngIf="last" (click)="addBtn();"></i>
                                        <i class="fa fa-minus ml1" *ngIf="last" (click)="deleteRow(i)"></i>
                                      </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="row col-sm-12">
                        <div class="col-sm-12 prpl">
                            <button *ngIf="editButton && sessCreate" type="button" [disabled]="subButton"
                                class="btn btn-primary btn-icon-text floatright mt-1" (click)="submitFun1()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                    Save
                                </span>
                            </button>
                            <button *ngIf="submitButton && sessCreate" type="button" [disabled]="subButton"
                                class="btn btn-primary btn-icon-text floatright mt-1" (click)="submitFun1()">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                    Save
                                </span>
                            </button>
                            <button type="button" [mat-dialog-close]="true"
                                class="btn btn-primary btn-icon-text floatright mr-3 mt-1">
                                <span style="display: contents; align-items: center;">
                                    <img width="20vh" src="../../assets/img/turn-left.gif" style="margin-right: 7px;">
                                    Back
                                </span>
                            </button>
                        </div>
                    </div>
                    <!-- <div class="row mt-2">
                                <div class="col-sm-3 pri-0 offset-sm-6 ">
                                    <button type="button" [mat-dialog-close]="true"
                                        class="btn btn-primary btn-icon-text floatright mt-1">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/img/list.gif" style="margin-right: 5px;">
                                            List
                                        </span>
                                    </button>
            
                                </div>
                                <div class="col-sm-3 pri-0" *ngIf="submitButton && sessCreate">
                                    <button type="button" class="btn btn-primary btn-icon-text floatright mt-1"
                                        (click)="submitFun1()">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                            Save
                                        </span>
                                    </button>
                                </div>
                                <div class="col-sm-3 pri-0" *ngIf="editButton && sessCreate">
                                    <button type="button" class="btn btn-primary btn-icon-text floatright mt-1"
                                        (click)="submitFun1()">
                                        <span style="display: contents; align-items: center;">
                                            <img width="20vh" src="../../assets/img/save.gif" style="margin-right: 5px;">
                                            Save
                                        </span>
                                    </button>
                                </div>
                            </div> -->


                </div>

            </div>
        </div>
    </form>
</div>